/**
 * Launch pricing closes at the end of the visitor's current day.
 *
 * Derived from the real clock (today at 23:59:59 local time), so the countdown
 * always shows less than 24 hours and never restarts on refresh.
 *
 * To close the promotion on a fixed date, set FIXED_DEADLINE to an ISO string.
 */
const FIXED_DEADLINE: string | null = null

export function getOfferDeadline(): string {
  if (FIXED_DEADLINE) return FIXED_DEADLINE
  const endOfDay = new Date()
  endOfDay.setHours(23, 59, 59, 999)
  return endOfDay.toISOString()
}
